// PLUGINS IMPORTS //
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

// COMPONENTS IMPORTS //
import BlogItem from '../BlogItem'
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //
import { BlogsData } from 'Content/Screens/GeneralScreens/BlogScreens/BlogListScreen/Data'

// REDUX
import { getBlogsThunkCreator } from 'Redux/Reducers/BlogsReducer'
import { getBlogsSelector } from 'Redux/Selectors/BlogsSelector'

/////////////////////////////////////////////////////////////////////////////

interface PropsType {}

const List: React.FC<PropsType> = () => {
  // const blogs = useSelector(getBlogsSelector)
  // const dispatch = useDispatch()

  // useEffect(() => {
  //   dispatch(getBlogsThunkCreator())
  // }, [])

  return (
    <Wrapper>
      {BlogsData.map((item) => (
        <BlogItem data={item} />
      ))}
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const MARGIN_RIGHT = 14
const Wrapper = styled.div`
  margin-left: ${MARGIN_RIGHT}%;
  margin-right: ${MARGIN_RIGHT - 14.5}%;
  margin-top: -25px;
`

export default React.memo(List, memoComparison)
